module.exports = __webpack_public_path__ + "static/modal_idcard_back.fd15fb1b.png";